module.exports = __webpack_public_path__ + "img/windows.9a6eeda1.svg";